import { render, staticRenderFns } from "./TutorsListWrapper.vue?vue&type=template&id=1b06c17b&"
import script from "./TutorsListWrapper.vue?vue&type=script&lang=js&"
export * from "./TutorsListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports